<script lang="ts">
	import CoreService from '@atoms/coreService/CoreService.svelte';
	import type { FeaturedServiceBlock } from './FeaturedServiceBlockQuery';
	import { breakpoints } from '@core/tools/Breakpoints.svelte';
	import { Carousel } from '@core/builders/carousel/Carousel.svelte';
	import { SnapAlign } from '@core/builders/carousel/modifiers/Snap';
	import { Headline } from '@atoms';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';

	const { data }: { data: FeaturedServiceBlock } = $props();

	const carousel = Carousel.from(data.services, {
		drag: true,
		setHeightToTallestItem: true,
		snap: { align: SnapAlign.START },
		autoRun: false
	});

	$effect(() => {
		if (!breakpoints.md) {
			carousel.start();
		} else {
			carousel.stop();
		}
		return () => carousel.stop();
	});
	createViewController();
</script>

<section use:ViewController>
	{#if data.headline}
		<div class="headline" use:EnterOnView>
			<Headline text={data.headline} />
		</div>
	{/if}

	<div class="drag-container" use:carousel.useContainer {...carousel.attr.container}>
		{#each carousel.items as service, i}
			<div class="item" use:service.useItem {...service.attr} use:EnterOnView={{ delay: i * 0.15 }}>
				<CoreService
					description={service.data.description}
					slug={service.data.service.slug}
					headline={service.data.service.service}
					illustration={service.data.illustration}
				/>
			</div>
		{/each}
	</div>
</section>

<style lang="scss">
	section {
		height: 100%;
		@include blockPadding;
	}
	.headline {
		margin-bottom: 66px;

		:global(.container) {
			grid-column: 1/-1;
		}
		@include layoutBlockGrid;
	}

	.drag-container {
		display: flex;
		grid-column: 1/-1;
		overflow: hidden;

		@include md {
			aspect-ratio: unset;
			@include layoutBlockGrid;
		}
	}

	.item {
		position: absolute;
		display: flex;

		width: 80vw;
		padding-left: 16px;

		@include md {
			position: relative;
			width: 100%;
			aspect-ratio: unset;
			grid-column: span 4;
			padding-left: 0;
		}
	}
</style>
